import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Api
import dashboard_api from '../../../api/dashboard_api';
import { showMessage } from 'helpers/message';
export default function ModalidadesVeiculos({ btnVoltar, id, modalidade, statusVeiculos }) {
    const [loading, setLoading] = useState(false);

    //Headers da tabela de veiculos por modalidade
    const headers = [
        { value: "Transportador", objectValue: "transportador" },
        { value: "Veículo", objectValue: "veiculo" },
        { value: "Implemento", objectValue: "implemento" },
        { value: "Validade do licenciamento do veiculo", objectValue: "validadeLicenciamento" },
        { value: "Status", objectValue: "status" },
    ];

    //Estado que guarda os dados da tabela
    const [veiculos, setVeiculos] = useState([]);

    //Carregando os dados da tabela
    useEffect(() => {
        setLoading(true);
        dashboard_api.VeiculosPorModalidade(id).then(response => {
            response.data = response.data.map(value => {
                value.validadeLicenciamento = moment(value.validadeLicenciamento).format("DD/MM/YYYY");
                value.statusLicenciamento = value.status;
                const status = value.status;
                value.status = () => {
                    return (
                        <span className='fw-bold p-1 rounded-3 ' style={status === "Vencido" ? { backgroundColor: "#e74c3c", color: "#fff", opacity: "80%" } : { backgroundColor: "#2ecc71", color: "#fff", opacity: "80%" }}>{status}</span>
                    );
                }
                return value;
            });

            setVeiculos(response.data.filter(f => f.statusLicenciamento == statusVeiculos));
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);

    return (
        <MainCard title={modalidade} noCard btnVoltarInTop={btnVoltar}>
            {loading && <Loading />}
            <TabelaListagem title='Lista de veiculos por modalidade' headers={headers} items={veiculos} options={{ print: false, search: true, pagination: true }} />
        </MainCard>
    );

}